import { render } from "./HRNavigation.vue?vue&type=template&id=b9b3f5c2&scoped=true"
import script from "./HRNavigation.vue?vue&type=script&lang=js"
export * from "./HRNavigation.vue?vue&type=script&lang=js"

import "./HRNavigation.vue?vue&type=style&index=0&id=b9b3f5c2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b9b3f5c2"

export default script